export const DESIGN_SLUGS = [
  "v1",
  "v2",
  "v3",
  "v4",
  "v5",
  "v6",
  "v7",
  "v8",
  "v9",
] as const;

export type DesignSlug = (typeof DESIGN_SLUGS)[number];

export const DEFAULT_DESIGN_SLUG: DesignSlug = "v1";

export function resolveDesignSlug(value: string | undefined): DesignSlug {
  return DESIGN_SLUGS.find((slug) => slug === value) ?? DEFAULT_DESIGN_SLUG;
}
